<template>
  <div class="edit-mesh-names">
    <div class="sticky-header">
      <h1>Mesh names</h1>
      <div class="sticky-header-button">
        <LoadingButton @click="updateMeshNames()" :loading="loading" :disabled="!formValid">Update</LoadingButton>
      </div>
    </div>

    <form class="default-form edit-mesh-names-form" @submit.prevent="">

      <div class="default-form-field">

        <div class="default-form-field-mesh-names">
          <div class="default-form-field-mesh-names-header default-form-field-mesh-names-edit-row">
            <span>meshName</span>
            <span></span>
          </div>

          <div v-for="(meshName, i) in meshNames" :key="meshName.id || i" class="default-form-field-mesh-names-edit-row">
            <input type="text" class="default-form-field-input" v-model.trim="meshName.meshName">

            <button class="default-form-field-button" tabindex="-1" @click="removeMeshName(i)">
              <mdicon name="minus" class="default-form-field-button-icon" size="25" />
            </button>
          </div>

          <button class="default-form-field-button" @click="addMeshName()">
            <mdicon name="plus" class="default-form-field-button-icon" size="25" />
          </button>
        </div>
      </div>

      <div class="default-form-button">
        <LoadingButton @click="updateMeshNames()" :loading="loading" :disabled="!formValid">Update</LoadingButton>
      </div>

    </form>
  </div>
</template>

<script>
  import isEqual from 'lodash.isequal'
  import { mapGetters } from 'vuex'
  import LoadingButton from '@/components/inputs/buttons/LoadingButton.vue'

  export default {
    name: "MeshNames",

    components: {
      LoadingButton
    },

    data () {
      return {
        meshNames: [],
        formValid: false,
        loading: false,
      }
    },

    methods: {
      async getMeshNames () {
        await this.$store.dispatch('getMeshNames')
        this.meshNames = JSON.parse(JSON.stringify(this.meshNamesStore))
      },

      async updateMeshNames () {
        this.loading = true

        try {
          await this.$store.dispatch('updateMeshNames', this.meshNames)
        } catch (err) {
          console.log(err)
          this.loading = false
        }

        this.loading = false
        this.meshNames = JSON.parse(JSON.stringify(this.meshNamesStore))
      },

      addMeshName () {
        this.meshNames.push({
          meshName: ""
        })
      },

      removeMeshName (i) {
        this.meshNames.splice(i, 1)
      }
    },

    computed: {
      ...mapGetters({
        meshNamesStore: "getMeshNames"
      }),
    },

    created () {
      this.getMeshNames()
    },

    watch: {
      meshNames: {
        deep: true,
        immediate: false,
        handler () {
          if (isEqual(this.meshNames, this.meshNamesStore)) {
            this.formValid = false
          } else {
            this.formValid = true
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.edit-mesh-names {
  display: flex;
  flex-direction: column;
  padding: 25px;
  align-items: center;
  min-width: min(100%, 800px);

  &-form {
    padding: 25px 0px;
    gap: 50px;
    min-width: min(100%, 800px);
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;

  h1 {
    margin: 0;
    text-align: left;
    flex: 1;
  }

  &-button {
    flex-shrink: 0;
    margin-left: 20px;
  }
}

.default-form-field-mesh-names {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex-grow: 1;
  align-items: center;
}

.default-form-field-mesh-names-header {
  font-size: 0.85rem;
  font-weight: 500;
  min-width: 100px;
  text-align: left;
  width: min(100%, 520px);
}

.default-form-field-mesh-names-edit-row {
  display: grid;
  grid-auto-flow: dense;
  grid-template-columns: 1fr 30px;
  justify-items: stretch;
  justify-content: center;
  gap: 5px;
  width: min(100%, 520px);
}

</style>
